<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>
    <v-row>
      <v-col cols="12" md="4" xs="12">
        <v-card elevation="2" outlined>
          <v-card-title class="d-flex justify-center text-subtitle-2">
            Áreas de configuración del sistema
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="d-flex">
                <v-checkbox v-model="selectAll" class="ma-0 pa-0" @change="selectAllCheckboxes" label="Seleccionar todos"
                  color="success" />
                <v-spacer></v-spacer>
                <ButtonComp :disabled="!areasSelecciondas.length" @click="agregarArea" icon-but="fas fa-plus"
                  text-button="Agregar" />

              </v-col>
              <v-col cols="12" v-if="Areas.length < 1">
                <v-card outlined>
                  <v-card-text style="height: 240px" class="d-flex text-center justify-center align-center">
                    Asegura haber seleccionado los Niveles para poder tener
                    acceso a las Áreas.
                  </v-card-text>
                </v-card>

              </v-col>
              <v-col cols="12" class="d-flex justify-center" v-for="area of Areas" :key="area.id">
                <v-card width="240" elevation="7" :style="{ 'border-left': 'solid 5px' + area.color }">
                  <v-list-item>
                    <v-list-item-avatar class="ml-0 mr-1" size="50" :color="area.color_area">
                      <v-icon dark>{{ area.icono_area }}</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content class="py-0">
                      <span class="overline mb-4">
                        {{ area.area_nivel_id }}
                      </span>
                      <span class="mb-1 black--text">
                        <h4>{{ area.desc_area }}</h4>
                      </span>
                    </v-list-item-content>
                  </v-list-item>

                  <v-card-text :style="{ background: area.color }" id="text">{{ area.desc_nivel }}</v-card-text>

                  <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-checkbox class="ma-0 pa-0" v-model="areasSelecciondas" :value="area.id" color="success"
                      :key="area.id" hide-details></v-checkbox>

                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="8" xs="12">
        <v-card outlined elevation="2">
          <v-card-title class="d-flex justify-center text-subtitle-2">
            Áreas del colegio
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" v-if="mostrarMensaje2">
                <v-card outlined>
                  <v-card-text style="height: 240px" class="d-flex text-center justify-center align-center">
                    Aún no has agregado ningún área al colegio, dar click en el botón
                    del área que dice agregar.
                  </v-card-text>
                </v-card>

              </v-col>

              <v-col cols="12">
                <div v-for="(item, i) in Areasadmin" :key="i" class="my-2">
                  <v-card outlined>
                    <v-card-title class="d-flex justify-center">
                      <v-chip :color="item.color_nivel" label dark>{{ item.desc_nivel }}</v-chip>
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" class="d-flex justify-center" v-for="(area, i) in item.areas"
                          :key="i">
                          <v-card outlined width="240" elevation="7" :style="{
                            'border-left': 'solid 5px' + item.color_nivel,
                          }">
                            <v-list-item>
                              <v-list-item-avatar class="ml-0 mr-1" size="50" :color="area.color_area">
                                <v-icon dark>{{ area.icono_area }}</v-icon>
                              </v-list-item-avatar>

                              <v-list-item-content class="py-0">
                                <div class="overline mb-4">
                                  {{ area.area_nivel_id }}

                                </div>

                                <span class="mb-1 black--text">
                                  <h4>{{ area.desc_area }}</h4>
                                </span>

                              </v-list-item-content>
                            </v-list-item>

                            <v-card-text :style="{ background: item.color_nivel }" id="text">{{ item.desc_nivel
                            }}</v-card-text>

                            <v-card-actions>
                              <v-col cols="12" md="" class="pb-md-0 pt-1 pb-xs-3 d-flex justify-end">
                                <ButtonComp v-if="componenteEvento.borrar_submodulo" @click="deleteArea(area.id)"
                                  deleteButton tooltipText="Eliminar área" />
                              </v-col>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- modal agregar nivel a mantenimiento --->
    <ComunDialogComp title="Confirmar" @close-modal="dialog = false" v-model="dialog" maxWidth="550">
      <template v-slot:body>
        <h3 class="text-center py-4">¿Está seguro de agregar las áreas seleccionadas al colegio?</h3>
        <span>Áreas seleccionadas:</span>
        <ul>
          <li v-for="(area, index) in dataAreasSeleccionadas" :key="index">
            {{ area.desc_area }} - {{ area.desc_nivel }}
          </li>
        </ul>
      </template>
      <template v-slot:actions>
        <v-spacer />
        <v-btn class="btn_style3" dark @click="dialog = false">No</v-btn>
        <v-btn class="btn_block_style2" :loading="isSaving" dark @click="addAdminAreas">Sí</v-btn>
      </template>
    </ComunDialogComp>

    <!--------fin modal-->

    <!-- modal - delete -->
    <confirm @aceptar="deleted" titleWindow="Eliminar área" @cancelar="clear_confirm" :title="confirm.title"
      :active="confirm.active" />
  </div>
</template>

<script>
import axios from "../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import ButtonComp from '../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../components/ComponentsEst/ComunDialogComp.vue';


export default {
  components: {
    ButtonComp,
    ComunDialogComp
  },
  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 15, id_modulo: 6 }, //sud_modulo y modulo

    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    selectAll: false,
    /// modal delete confirm
    confirm: {
      id: 0,
      title: "",
      active: false,
    },

    //areas de mantemiento
    Areas: [],
    mostrarMensaje: false,

    // areas del colegio
    NivelAreaAdmin: [],
    Areasadmin: [],
    mostrarMensaje2: false,
    areaParams: {
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_colegio_adm_nivel: sessionStorage.id_colegio,
    },

    // modal agregar area
    dialog: false,

    nombreArea: "",
    iconoArea: "",
    colorArea: "",
    colorNivel: "",
    descNivel: "",

    editedAreas: {
      id_area: 0,
      id_nivel: 0,
      id_usuario: sessionStorage.id,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_colegio: sessionStorage.id_colegio,
    },

    defaultAreas: {
      id_area: 0,
      id_nivel: 0,
      id_usuario: sessionStorage.id,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_colegio: sessionStorage.id_colegio,
    },

    areasSelecciondas: [], //Areas seleccionadas para agregar
    isSaving: false
  }),

  mounted() {
    this.loadMain();
  },

  created() {
    this.actualizarParamentro();
  },

  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    dataAreasSeleccionadas() {
      return this.Areas.filter(e => this.areasSelecciondas.includes(e.id))
    }
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //-------cargar registros------------
    async loadMain() {
      this.getNivelAreaAdmin();
      this.getAllAreas();
      this.getAllAreasAdmin();
    },
    clear_confirm() {
      this.confirm.id = 0;
      this.confirm.title = "";
      this.confirm.active = false;
    },

    selectAllCheckboxes() {
      if (this.selectAll) {
        // Si el checkbox "Seleccionar Todos" está marcado, seleccionar todos los niveles
        this.areasSelecciondas = this.Areas.map((area) => area.id);
      } else {
        // Si el checkbox "Seleccionar Todos" está desmarcado, deseleccionar todos los niveles
        this.areasSelecciondas = [];
      }
    },

    //----------  Obtener Niveles y Areas Administrativos por Periodos y colegio -----
    async getNivelAreaAdmin() {
      try {
        let response = await axios.get(
          `/administrativo/area/nivelArea/ano_lectivo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}`
        );
        this.NivelAreaAdmin = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //----------traer areas de mantenimiento ----------------
    async getAllAreas() {
      var params = {
        id_colegio: this.datoLogin.id_colegio,
        id_anio_lectivo: this.datoLogin.id_ano_lectivo,
      };

      try {
        let response = await axios.post("/administrativo/area/filt/", params);
        this.Areas = response.data;
        // console.log('areas de mantenimiento======>>>'+JSON.stringify(this.Areas))
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //-------------areas administracion colegio -----------
    async getAllAreasAdmin() {
      this.mostrarMensaje2 = false;
      this.mostrarMensaje = false;
      // let params = this.areaParams;

      try {
        let response = await axios.get(
          `/administrativo/area/nivelArea/ano_lectivo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}`
        );
        this.Areasadmin = response.data;
        // console.log('areas de mantenimiento======>>>'+JSON.stringify(this.Areasadmin))
        if (this.Areasadmin.length === 0) {
          this.mostrarMensaje2 = true;
        }

        if (this.Areas.length === 0 && this.Areasadmin.length === 0) {
          this.mostrarMensaje = true;
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //---------Seleccionar Area --------------
    agregarArea() {
      // esto toma las areas seleccionadas y las "mueve" (actualiza)
      // Abre el modal
      this.dialog = true;
      // define unos parametros para 
      // this.editedAreas.id_area = area.id;
      // this.editedAreas.id_nivel = area.id_nivel;

      // // 
      // this.nombreArea = area.desc_area;
      // this.iconoArea = area.icono_area;
      // this.colorArea = area.color_area;
      // this.colorNivel = area.color;
      // this.descNivel = area.desc_nivel;
    },

    //----------Nueva creacion de areas------
    async addAdminAreas() {
      this.isSaving = true

      // Esto toma las el array de ids seleccionadas areasSelecciondas
      // let params = this.editedAreas;
      try {

        const areaBase = {
          id_usuario: sessionStorage.id,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_colegio: sessionStorage.id_colegio,
        }

        const arrayPromesas = [] //Array de promesas de cada post de las areas

        this.dataAreasSeleccionadas.forEach(area => {

          const params = {
            ...areaBase,
            id_area: area.id,
            id_nivel: area.id_nivel
          }
          arrayPromesas.push(axios.post("/administrativo/area/", params))

        });

        await Promise.all(arrayPromesas)
        this.isSaving = false


        await this.getAllAreasAdmin();
        await this.getAllAreas();

        // si todo salió bien se vacia el array areasSelecciondas
        this.areasSelecciondas.splice(0)
        // dataAreasSeleccionadas se vaciará tambien por ser computada

        this.dialog = false;
        this.editedAreas = Object.assign({}, this.defaultAreas);



        this.setEnviarMens({
          tipo: "S",
          mensaje: `¡Información creada con éxito!`,
          tiempo: null,
        });
        //console.log(response);
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //-- 19-05-2020. LUIS ROJAS.
    //-- METODO QUE PERMITE ELIMINAR UN AREA DEL AMBITO DE MANTENIMIENTO
    //-- SIEMPRE Y CUANDO NO SE ENCUENTRE ASOCIADO A OTRO REGISTRO EN LA BASE DE DATOS
    //------------borrar area -------------
    async deleteArea(id) {
      this.confirm.id = id;
      this.confirm.title = "¿Está seguro de eliminar este registro?";
      this.confirm.active = true;
    },
    async deleted() {
      await axios
        .delete("/administrativo/area/" + this.confirm.id)
        .then((response) => {
          this.clear_confirm();
          if (JSON.stringify(response.data.mti) == JSON.stringify("S")) {
            this.dialog = false;
            this.getAllAreasAdmin();
            this.getAllAreas();
            this.setEnviarMens({
              tipo: "S",
              mensaje: response.data.message,
              tiempo: null,
            });
          } else {
            this.setEnviarMens({
              tipo: "W",
              mensaje: response.data.message,
              tiempo: null,
            });
          }
        });
      return false;
    },
  },
};
</script>

<style scoped>
#text {
  color: #ffffff;
  padding: 1%;
  padding-left: 10%;
}
</style>